module.exports = __webpack_public_path__ + "images/home/index/screenshot-browser-2-ab34231620d8496154d073900ce73a3f.png";